import React from 'react'
import './Table.css'
import { NavLink } from 'react-router-dom';

const Card = ({ data, sector, link }) => {
    const uniqueData = data.filter(
        (item, index, arr) => arr.findIndex((i) => i.cftc_contract_market_code === item.cftc_contract_market_code) === index
    );
    const sectorData = uniqueData.filter(item => item.sector === sector);
    return (
        <>
            <h2 className='fw-bold'>{sector}</h2>
            <div className='carddiv'>
                {sectorData.map((item) => (
                    <div key={item.cftc_contract_market_code} className='smallcard' style={{ width: "100%", backgroundColor: "white", borderRadius: "1px", padding: "5px", height: "80px" }}>
                        <NavLink to={`/cot/${link}/${item.symbol}`} style={{ color: "gray", textDecoration: "none", fontWeight: "bolder" }}>
                            {item.short_name}
                        </NavLink>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Card